import { css } from '@emotion/react';
import { ReactNode } from 'react';
import { theme } from 'styles/theme';

export const Label = ({
	required,
	children,
	labelWidth,
	htmlFor,
	vertical,
	desc,
}: {
	required?: boolean;
	children: ReactNode;
	labelWidth?: number;
	htmlFor?: string;
	vertical?: boolean;
	desc?: ReactNode;
}) => {
	return (
		<label
			css={css`
				font-size: 14px;
				line-height: 20px;
				flex-shrink: 0;
				margin-bottom: 0;
				${labelWidth &&
				css`
					width: ${labelWidth}px;
				`}

				${vertical &&
				css`
					margin-bottom: 8px;
				`}

				&:hover {
					cursor: pointer;
				}
			`}
			htmlFor={htmlFor}
		>
			<div>
				{children}
				{required && (
					<span
						css={css`
							padding-left: 2px;
							color: #ff6767;
						`}
					>
						*
					</span>
				)}
			</div>

			<div
				css={css`
					font-size: 13px;
					line-height: 20px;
					color: ${theme.color.text['300']};
				`}
			>
				{desc}
			</div>
		</label>
	);
};
